module.exports = __webpack_public_path__ + "static/img/7b9c4249c67ef6f6e8f36eea98806a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ck_box.png
// module id = PIVb
// module chunks = 1